import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { ToastrService } from 'ngx-toastr';

@AutoUnsubscribe()
@Component({
  selector: 'add-subfolder',
  templateUrl: './add-subfolder.component.html',
  styleUrls: ['./add-subfolder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddSubfolderComponent {
  subfolderName = 'Untitled folder';

  constructor(private dialogRef: MatDialogRef<AddSubfolderComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService) {
    if (this.data.title == 'New Group') {
      this.subfolderName = 'Untitled group';
    }
  }
  selectAllContent($event) {
    $event.target.select();
  }

  handleInput(event) {
    this.subfolderName = event.target.value;
  }

  confirmDialog() {
    if (this.subfolderName !== '') {
      this.dialogRef.close({
        confirmation: true,
        subfolderName: this.subfolderName,
      });
    } else {
      this.toastr.error('Please provide a folder name');
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  checkIfDisabled() {
    if (this.subfolderName.replace(/\s/g, '').length == 0) {
      return true;
    }
  }
}
